export default __webpack_public_path__ + "4a6e6dfdd9fa69d8b26bba23499217f2.png";